import React, { useState, useEffect } from 'react'
import { Switch } from '@mui/material'

export default function Roles(props) {
    const [activeTab, setActiveTab] = useState(1)
    const [codigoRol, setCodigoRol] = useState('')
    const [nombreRol, setNombreRol] = useState('')
    const [descripcionRol, setDescripcionRol] = useState('')
    const [permisosData, setPermisosData] = useState([])
    const [permisos, setPermisos] = useState({})
    const [collapsedSections, setCollapsedSections] = useState({})

    useEffect(() => {
        const codigoRol = localStorage.getItem("codigoRol");
        const nombreRol = localStorage.getItem("nombreRol");
        const descripcionRol = localStorage.getItem("descripcionRol");

        if (codigoRol && nombreRol && descripcionRol) {
            setCodigoRol(codigoRol);
            setNombreRol(nombreRol);
            setDescripcionRol(descripcionRol);
        } else if (props.formData.Codigo) {
            const datForm = props.formData;
            setCodigoRol(datForm["Codigo"]);
            setNombreRol(datForm["Nombre"]);
            setDescripcionRol(datForm["Descripcion"]);

            localStorage.setItem("codigoRol", datForm["Codigo"]);
            localStorage.setItem("nombreRol", datForm["Nombre"]);
            localStorage.setItem("descripcionRol", datForm["Descripcion"]);
        }
        const localStorageData = JSON.parse(localStorage.getItem('usuarioMenu')) || []
        const localStorageDataApp = JSON.parse(localStorage.getItem('appMenu')) || []

        const transformedData = localStorageDataApp.map(opcion => ({
            section: opcion.descripcionOpcion,
            permisos: opcion.acciones.length > 0
                ? opcion.acciones.map(accion => ({
                    name: `${opcion.codigoOpcion}-${accion.codigoAccion}`, // Usar codigoAccion
                    label: accion.descripcion, // Mostrar la descripcion
                    id: opcion.codigoOpcion,
                    codigoAccion: accion.codigoAccion
                }))
                : [{
                    name: `${opcion.codigoOpcion}`,
                    label: opcion.descripcionOpcion, // Si no tiene acciones, usar descripcionOpcion
                    id: opcion.codigoOpcion
                }]
        }));
        const initialPermisos = {}
        const initialCollapsedSections = {}
        transformedData.forEach(section => {
            section.permisos.forEach(permiso => {
                initialPermisos[permiso.name] = false
            })
            initialCollapsedSections[section.section.toLowerCase()] = true
        })
        setPermisosData(transformedData)
        setPermisos(initialPermisos)
        setCollapsedSections(initialCollapsedSections)
    }, [])

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex)
    }

    const handlePermisosChange = (permisoName) => {
        setPermisos({
            ...permisos,
            [permisoName]: !permisos[permisoName],
        })
    }

    const toggleSection = (section) => {
        setCollapsedSections({
            ...collapsedSections,
            [section]: !collapsedSections[section],
        })
    }

    const handleSave = () => {
        if (!codigoRol || !nombreRol || !descripcionRol) {
            alert('Todos los campos son obligatorios')
            return
        }
        const opcionesSeleccionadas = permisosData.reduce((result, section) => {
            const opciones = section.permisos.filter(permiso => permisos[permiso.name]).map(permiso => ({
                codigoOpcion: permiso.id,
                esActivo: "S",
                usuarioCreacion: "Cristhofer Creacion",
                usuarioModificacion: "Cristhofer Actualizacion",
                listAcciones: permiso.id
                    ? [{
                        codigoAccion: permiso.codigoAccion,
                        esActivo: "S",
                        usuarioCreacion: "Cristhofer Creacion",
                        usuarioModificacion: "Cristhofer Actualizacion"
                    }]
                    : []
            }))
            return [...result, ...opciones]
        }, [])
        if (opcionesSeleccionadas.length === 0) {
            alert('Debe seleccionar al menos una opción')
            return
        }
        const payload = {
            status: "load",
            codigoRol,
            nombreRol,
            descripcionRol,
            esActivo: "S",
            usuarioCreacion: "Cristhofer Creacion",
            usuarioModificacion: "Cristhofer Actualizacion",
            listOpciones: opcionesSeleccionadas
        }
        localStorage.setItem("rolData", JSON.stringify(payload))
    }

    return (
        <div className="container mt-4">
            <div className="d-flex justify-content-center mb-3">
                <button
                    className={`btn ${activeTab === 1 ? 'btn-light' : 'btn-outline-light border'}`}
                    onClick={(e) => {
                        e.preventDefault()
                        handleTabClick(1)
                    }}>
                    1 Nuevo Rol
                </button>
                <span className="mx-2">➔</span>
                <button
                    className={`btn ${activeTab === 2 ? 'btn-light' : 'btn-outline-light border'}`}
                    onClick={(e) => {
                        e.preventDefault()
                        handleTabClick(2)
                    }}>
                    2 Permisos
                </button>
            </div>
            <div className="card">
                {activeTab === 1 && (
                    <div className="card-body">
                        <h5>Crear Rol</h5>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Código</label>
                                    <input
                                        disabled
                                        type="text"
                                        className="form-control"
                                        placeholder="Código"
                                        value={codigoRol}
                                        onChange={(e) => setCodigoRol(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Nombre</label>
                                    <input
                                        disabled
                                        type="text"
                                        className="form-control"
                                        placeholder="Nombre"
                                        value={nombreRol}
                                        onChange={(e) => setNombreRol(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>Descripción</label>
                                    <textarea
                                        disabled
                                        className="form-control"
                                        placeholder="Descripción"
                                        value={descripcionRol}
                                        onChange={(e) => setDescripcionRol(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <button className="btn btn-primary" onClick={() => handleTabClick(2)}>Siguiente</button>
                            </div>
                        </div>
                    </div>
                )}
                {activeTab === 2 && (
                    <div className="card-body">
                        <h5>Asignar Permisos</h5>
                        <p>Administrador de accesos para el rol</p>
                        {permisosData.map((section, index) => (
                            <div key={index} className="mb-3">
                                <h6 className="d-flex justify-content-between align-items-center">
                                    <span
                                        onClick={() => toggleSection(section.section.toLowerCase())}
                                        style={{ cursor: 'pointer' }}>
                                        <span className="collapse-icon">
                                            {collapsedSections[section.section.toLowerCase()] ? '-' : '+'}
                                        </span> {section.section}
                                    </span>
                                </h6>
                                {collapsedSections[section.section.toLowerCase()] && (
                                    <div className="submenu">
                                        {section.permisos.map((permiso, permisoIndex) => (
                                            <div key={permisoIndex} className="d-flex justify-content-between align-items-center">
                                                <label>{permiso.label}</label>
                                                <Switch
                                                    checked={permisos[permiso.name]}
                                                    disabled
                                                    onChange={() => handlePermisosChange(permiso.name)}
                                                    color="primary"
                                                />
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                        <div className="d-flex justify-content-between">
                            <button className="btn btn-primary" onClick={() => handleTabClick(1)}>Atrás</button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}
